import React, { useState } from "react";

const YouTubeEmbed = ({ videoUrl, videoType, unrestricted = false }) => {
  const isRestricted = videoType === 0 && !unrestricted;
  const applyInteractionGuards = !unrestricted;
  // Extract YouTube video ID from URL
  const getYouTubeVideoId = (url) => {
    if (!url) return null;

    // Handle different YouTube URL formats
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // Iframe-specific right-click prevention
  const handleIframeContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const handleIframeMouseDown = (e) => {
    if (e.button === 2) { // Right mouse button
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  // Play/Pause state
  const [isPlaying, setIsPlaying] = useState(false);

  // Play/Pause toggle handler
  const handlePlayPauseToggle = () => {
    const iframe = document.querySelector('iframe[title="YouTube video"]');
    if (iframe) {
      if (isPlaying) {
        // Pause the video
        iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        setIsPlaying(false);
      } else {
        // Play the video
        iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        setIsPlaying(true);
      }
    }
  };

  const videoId = getYouTubeVideoId(videoUrl);

  if (!videoId) {
    return (
      <div dangerouslySetInnerHTML={{ __html: videoUrl }}></div>
    );
  }

  const src = isRestricted ? `https://www.youtube.com/embed/${videoId}?controls=0&rel=0&autoplay=0&modestbranding=1&showinfo=0&iv_load_policy=3&playsinline=1&fs=0&cc_load_policy=0&enablejsapi=1` : `https://www.youtube.com/embed/${videoId}`;

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        paddingBottom: '56.25%',
        ...(applyInteractionGuards && {
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          pointerEvents: 'auto',
        }),
      }}
      {...(applyInteractionGuards && {
        onContextMenu: handleIframeContextMenu,
        onMouseDown: handleIframeMouseDown,
        onSelectStart: (e) => e.preventDefault(),
        onDragStart: (e) => e.preventDefault(),
      })}
    >
      <iframe
        src={src}
        allow="autoplay; encrypted-media"
        allowFullScreen
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        title="YouTube video"
        {...(applyInteractionGuards && {
          onContextMenu: (e) => e.preventDefault(),
          onMouseDown: (e) => e.preventDefault(),
        })}
      />
      
      {/* Title and share button blocker (top) */}
      {isRestricted && <div
        className="title-blocker"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          zIndex: 9999,
          pointerEvents: 'auto',
          cursor: 'default',
        }}
        onContextMenu={handleIframeContextMenu}
        onMouseDown={handleIframeMouseDown}
      />}
      
      {/* Logo blocker (bottom-right) */}
      {/* <div
        className="logo-blocker"
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '130px',
          height: '70px',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 9999,
          pointerEvents: 'auto',
          borderRadius: '4px 0 0 0',
          cursor: 'default',
        }}
        onContextMenu={handleIframeContextMenu}
        onMouseDown={handleIframeMouseDown}
      /> */}
      
      {/* Additional overlay to catch any missed right-clicks */}
      {isRestricted && <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 10000,
          pointerEvents: 'none',
        }}
        onContextMenu={handleIframeContextMenu}
        onMouseDown={handleIframeMouseDown}
      />}
    </div>
  );
};

export default YouTubeEmbed; 